import {ContentPopperProps} from '@aboutyou/ui-components';
import React from 'react';
import {CouponDeepLinkActivation} from '../../../features/CouponDeepLinkActivation/CouponDeepLinkActivation';
import {useActivateBasketCoupon} from './utils/useActivateBasketCoupon';

export const BasketCouponDeepLinkActivation: React.FC<{
  LayoutComponent: ContentPopperProps['LayoutComponent'];
}> = ({LayoutComponent}) => {
  const {isOpen, couponActivationResponse} = useActivateBasketCoupon();
  return (
    <CouponDeepLinkActivation
      data-testid="couponActivationComponent"
      isOpen={isOpen}
      LayoutComponent={LayoutComponent}
      {...couponActivationResponse}
    />
  );
};
